import actions from '@/store/modules/label/actions.js'
import mutations from '@/store/modules/label/mutations.js'
import getters from '@/store/modules/label/getters.js'
import {base_state} from '@/store/modules/base/state.js'

const state = {
  ...base_state,
  'api_module': 'label',
  'loaded_for_project_id': false,
  'loading': false,
  'loaded': false
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}